module.exports = __webpack_public_path__ + "images/emoji/wolf.f0ec492521232fdf629b.png";